import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useMutationCancelUserOrder } from "services/api/mutations/useMutationCancelUserOrder";
import { IShoppingBagData } from "types/ShoppingBag";
import { useSearchParams } from "react-router-dom";

type Props = {
  open: boolean;
  handleCloseDialog: () => void;
  order: IShoppingBagData;
};

function CancelUserOrderConfirmDialog({ open, handleCloseDialog, order }: Props) {
  const [searchParams] = useSearchParams();
  const table = searchParams.get("table") ? Number(searchParams.get("table")) : undefined;
  const customOriginQrCode = searchParams.get("origin") ?  Number(searchParams.get("origin")) : undefined;


  const { mutate: cancelUserOrder } = useMutationCancelUserOrder();
  const confirmCancel = async () => {
    order.status = 4;
    await cancelUserOrder(order);
    handleCloseDialog();
    // console.log('open', open);
    // console.log('handleCloseDialog', handleCloseDialog);
    // console.log('order', order);
  };
  return (
    <Dialog open={open} onClose={() => handleCloseDialog} onBackdropClick={() => handleCloseDialog()}> 
      <DialogTitle id="confirm-dialog">
        Deseja realmente cancelar a compra?
      </DialogTitle>
      <DialogActions>
        <Button variant="outlined" onClick={() => handleCloseDialog()}>
          Não
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            handleCloseDialog();
            confirmCancel();
          }}
        >
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelUserOrderConfirmDialog;
